import upsell from "../upsell"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("premium"),

  init() {
    this.commonInit()
  },

  onInit() {
    this.initUpsell()
  },
})
